module.exports = __webpack_public_path__ + "img/zuijia_08.6cece1a8.png";